import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import PropTypes from 'prop-types';

import ColoredSectionContainer from 'components/no-auth/common/ColoredSectionContainer';
import { PromoCountriesColumns } from 'components/no-auth/common/PromoCountries/PromoCountriesColumns';
import PromoCountryItemPlain from 'components/no-auth/common/PromoCountries/PromoCountryItemPlain';
import { PromoPageContainer } from 'components/no-auth/common/PromoPageContainer/PromoPageContainer';
import HeadingSection from 'components/no-auth/common/sections/HeadingSection';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

import { getLangCountryPrefix, toLowerCase } from 'helpers/utils';

const SelectRegionPage = (props) => {
    const [prevPathSlug, setPrevPathSlug] = useState('');
    const location = useLocation();

    useEffect(() => {
        setPrevPathSlug(location?.state?.prevSlug ?? sessionStorage?.getItem('prevSlug') ?? '');
    }, [location]);

    const getCountries = (data) => {
        return data
            .filter((item) => item !== null)
            .map((country) => {
                return (
                    <li key={country.id}>
                        {country.code_a2 && (
                            <>
                                <PromoCountryItemPlain
                                    href={`${getLangCountryPrefix(props.lang, toLowerCase(country.code_a2))}/${prevPathSlug}`}
                                    flagName={toLowerCase(country.code_a2)}
                                    countryName={country.name}
                                />
                            </>
                        )}
                    </li>
                );
            });
    };
    return (
        <PromoPageContainer bgColor={'eggshell02'}>
            <ColoredSectionContainer>
                {props.mainTitle && <HeadingSection title={props.mainTitle} titleTag={'h1'} />}
                {Array.isArray(props.countriesSections) &&
                    props.countriesSections
                        .filter((item) => item !== null)
                        .map((item) => {
                            return (
                                <React.Fragment key={item.id}>
                                    {item.title && <HeadingSection titleVariant="h3" title={item.title} textLeft noBottomIndent />}
                                    {item.countries_list && Array.isArray(item.countries_list) && (
                                        <PromoCountriesColumns>{getCountries(item.countries_list)}</PromoCountriesColumns>
                                    )}
                                </React.Fragment>
                            );
                        })}
            </ColoredSectionContainer>
        </PromoPageContainer>
    );
};
const mapStateToProps = (state) => {
    return {
        mainTitle: state.extra?.strapiApi?.title,
        countriesSections: state.extra?.strapiApi?.section,
        lang: state.extra.noAuthFooter?.language?.lang,
    };
};
SelectRegionPage.propTypes = {
    mainTitle: PropTypes.string,
    countriesSections: PropTypes.array,
    lang: PropTypes.string.isRequired,
};
export default connect(mapStateToProps)(NotAuthBasePage(SelectRegionPage));
